module.exports = __webpack_public_path__ + "assets/983334ff5391832e5f87ea7c579e4c5c.mp3";